export default "__VITE_ASSET__CBkkfmp3__"